import React, { useState } from "react";
const DefaultCtrl = ({ onClick, allShowed }) => {
  return (
    <a style={{ padding: "0 10px" }} onClick={onClick}>
      {allShowed ? "收起" : "更多"}
    </a>
  );
};
export default ({ children, maxNum = 10, Ctrl = DefaultCtrl }) => {
  const [allShowed, showAll] = useState(false);
  return (
    <>
      {React.Children.map(children, (child, index) =>
        index >= maxNum && !allShowed ? null : child
      )}
      <Ctrl onClick={() => showAll(!allShowed)} allShowed={allShowed} />
    </>
  );
};
